import { GetPaymentMethods } from '../contracts';
import axios from 'axios';
import CookieHelper from '../../utils/cookieHelper';
import StatusCode from 'status-code-enum';
import { ErrorType } from '../../shared/types';
import { LogCannon } from '@ace-clublabs/log-cannon';
import { createAxiosConfig } from '../mockHelper';
import { BrokerRegion } from '@ace-clublabs/payment-types';

export const GetPaymentMethodsApi =
  (endpoint: string): GetPaymentMethods =>
  async (testRegion?: BrokerRegion) => {
    try {
      const scenario = CookieHelper.getCookie('scenario');
      LogCannon.blast('GetPaymentMethodsApi scenario', { scenario });

      const modifiedEndpoint = testRegion ? `${endpoint}?brokerRegion=${testRegion}` : endpoint;
      LogCannon.blast('GetPaymentMethodsApi start', { modifiedEndpoint });
      const response = await axios.get(`${modifiedEndpoint}`, createAxiosConfig(scenario, modifiedEndpoint, true));
      LogCannon.blast('GetPaymentMethodsApi success');
      return Promise.resolve(response.data);
    } catch (error: any) {
      LogCannon.error('GetPaymentMethodsApi error', { statusCode: error?.response?.status, error: error?.message });
      if (error.response) {
        const statusCode = error.response.status;
        const errorMessage = error.response.data?.message || error?.message || error.response.data.error.message;
        if (statusCode === StatusCode.ClientErrorUnauthorized) {
          return Promise.reject({
            message: errorMessage,
            type: ErrorType.SESSION_TIMEOUT,
          });
        }

        if (statusCode === StatusCode.ClientErrorForbidden) {
          return Promise.reject({
            message: errorMessage,
            type: ErrorType.AUTH_ERROR,
          });
        }

        return Promise.reject({
          message: errorMessage,
          type: ErrorType.SYSTEM_ERROR,
        });
      }
      return Promise.reject({
        message: error,
      });
    }
  };
